<!--
 * @Author: xuesong
 * @Date: 2021-04-19 10:51:27
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-05-13 11:52:31
 * @Description: 系统消息-会诊-服务卡片
-->
<template>
  <div class="custom-sysix">
    <div class="info-content">
      <div class="top">
        <div class="text-title"><span>{{data.patientName}}</span><span>会诊房间已开启</span></div>
        <div class="text-sign">发起人：{{data.fromDoctorName}}</div>
        <div class="text-sign">参与专家：{{data.admissionName}}</div>
      </div>
      <div class="bot" @click="joinVideo()">
        <span>立即加入</span>
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    joinVideo() {   
      this.$emit("childToRoom", this.data.groupCode,false,this.data.synergyId);
    }
  }
};
</script>
  
  <style scoped lang="less">
.custom-sysix {
  position: relative;
  width: 350px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  padding: 12px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(204, 204, 204, 0.2);
  border: 1px solid #f5f5f5;
  .info-content {
    display: flex;
    flex-direction: column;
    width: 100%;
    font-size: 12px;
    font-weight: 500;
    .top {
      display: flex;
      flex-direction: column;
      text-align: left;
      .text-title {
        span {
          font-size: 13px;
          color: #333333;
          font-weight: 500;
          &:last-child {
            font-size: 12px;
            margin-left: 8px;
          }
        }
      }
      .text-sign {
        font-size: 12px;
        color: #666666;
        margin-top: 3px;
        &:last-child {
          margin-top: 8px;
        }
      }
    }
    .bot {
      text-align: right;
      margin-top: 8px;
      border-top: 1px solid #eeeeee;
      padding-top: 13px;
      color: #333333;
      i {
        margin-left: 8px;
      }
    }
  }
}
</style>